import IDeclarationOfficeVm from "./IDeclarationOfficeVm"
import { CriminalRecordDeclarationStatus } from "./../enums/CriminalRecordDeclarationStatus"

import * as IDeclarationOfficeVmInstance from "./IDeclarationOfficeVm"

export default interface ICriminalRecordDeclarationVm {
    id: string
    status: CriminalRecordDeclarationStatus
    date: string
    journalNumber: string
    declarationOffice: IDeclarationOfficeVm
}

export const empty = (enableIteration: boolean = true): ICriminalRecordDeclarationVm => {
	return {
		id: "",
		status: CriminalRecordDeclarationStatus.NotSet,
		date: "",
		journalNumber: "",
		declarationOffice: IDeclarationOfficeVmInstance.empty()
	} as ICriminalRecordDeclarationVm
}